import styled from 'styled-components';

export * from 'theme/mixins';

export const Wrapper = styled.div`
  display: block;
  color: ${({ theme }) => theme.colors.neutralPrimaryDark2};
`;

